import { useEffect, useState } from 'react'

function useDebouncedValue<T>(value: T, delay: number = 100) {
  const [throttledValue, setThrottledValue] = useState(value)
  useEffect(() => {
    const timeout = setTimeout(() => setThrottledValue(value), delay)
    return () => clearTimeout(timeout)
  }, [value, delay])
  return throttledValue
}

export default useDebouncedValue
